"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      width: '100%'
    },
    head: {
      fontSize: 'body',
      fontWeight: 600
    },
    cell: {
      flexGrow: 1
    }
  };
});

var nameReplacer = function nameReplacer(name) {
  return name.charAt(0).toUpperCase() + name.slice(1).replace(/_/g, ' ');
};

var DynamicDataTable = function DynamicDataTable(_ref) {
  var data = _ref.data,
      isPercentage = _ref.isPercentage;
  var classes = useStyles();

  var _useState = (0, _react.useState)(data),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      dynamicData = _useState2[0],
      setDynamicData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      order = _useState4[0],
      setOrder = _useState4[1];

  var tableHead = Object.getOwnPropertyNames(data[0] || {});
  (0, _react.useEffect)(function () {
    setDynamicData(data);
  }, [data]);

  var dynamicSort = function dynamicSort(name) {
    setOrder(!order);
    var sorted = (0, _toConsumableArray2["default"])(dynamicData).sort(function (a, b) {
      if (order ? a[name] < b[name] : a[name] > b[name]) {
        return -1;
      }

      if (order ? a[name] > b[name] : a[name] < b[name]) {
        return 1;
      }

      return 0;
    });
    setDynamicData(sorted);
  };

  var headList = tableHead.map(function (name) {
    return /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
      key: name,
      className: classes.head,
      onClick: function onClick() {
        return dynamicSort(name);
      }
    }, nameReplacer(name));
  });
  var bodyList = dynamicData.map(function (row, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.TableRow, {
      key: i
    }, Object.values(row).map(function (column, i) {
      return /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
        key: i
      }, column.toLocaleString(), "".concat(isPercentage ? "%" : ''));
    }));
  });
  return /*#__PURE__*/_react["default"].createElement(_core.TableContainer, {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.Table, {
    stickyHeader: true
  }, /*#__PURE__*/_react["default"].createElement(_core.TableHead, null, /*#__PURE__*/_react["default"].createElement(_core.TableRow, null, headList)), /*#__PURE__*/_react["default"].createElement(_core.TableBody, null, bodyList)));
};

DynamicDataTable.propTypes = {
  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
  isPercentage: false
};
DynamicDataTable.defaultProps = {
  data: []
};
var _default = DynamicDataTable;
exports["default"] = _default;